import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

import bgImage from './success_bg.jpg';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import Dialog from '@material-ui/core/Dialog';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10,
    backgroundImage: `url(${bgImage})`,
    backgroundColor: theme.palette.primary['50'],
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1),
  },
  inner: {
    maxWidth: 500,
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    backgroundColor: theme.palette.background.paper,
    boxShadow:
      '0px 16px 24px rgba(184, 51, 0, 0.06), 0px 2px 6px rgba(184, 51, 0, 0.04), 0px 0px 1px rgba(184, 51, 0, 0.04)',
  },
}));

const Success = ({ values }) => {
  const classes = useStyles();
  const [showModal, setShowModal] = useState(false);

  return (
    <Box className={classes.root}>
      <Box padding={5} className={classes.inner}>
        <Typography gutterBottom variant="h3">
          Welcome to WeAdmit
        </Typography>
        <Typography variant="body2">
          Thank you for choosing WeAdmit. Your child’s journey to their
          perfect-fit college begins today.
        </Typography>
        <Box marginTop={2}>
          <Typography variant="caption">
            {values.parent.email ? (
              <>
                Account login credentials have been sent to{' '}
                <strong>{values.parent.email}</strong> and{' '}
                <strong>{values.student.email}</strong>.
              </>
            ) : (
              <>
                Account login credentials have been sent to{' '}
                <strong>{values.student.email}</strong>.
              </>
            )}
          </Typography>
        </Box>
        <Box marginTop={3}>
          <Button
            size="large"
            startIcon={<PlayCircleFilledIcon />}
            variant="text"
            color="primary"
            onClick={() => setShowModal(true)}
            classes={{
              label: classes.btnLabelBold,
            }}
          >
            Watch Onboarding Video
          </Button>
        </Box>
      </Box>
      {showModal && (
        <Dialog
          open
          fullWidth
          maxWidth={'lg'}
          onBackdropClick={() => setShowModal(false)}
        >
          <div className="video-wrapper">
            <video
              autoPlay
              width="100%"
              height="auto"
              controls
              src="https://weadmit-static.s3.us-east-2.amazonaws.com/weadmit-intro.mp4"
            />
          </div>
        </Dialog>
      )}
    </Box>
  );
};

export default Success;
